var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6328 14.2517L14.8302 11.4455C15.2549 10.5102 15.5096 9.57479 15.5096 8.55438C15.5096 6.68363 14.8302 4.98295 13.4714 3.70744C10.7538 0.986354 6.42259 0.986354 3.70496 3.70744C0.987342 6.42853 0.987342 10.7653 3.70496 13.4864C4.97885 14.7619 6.76229 15.5272 8.54573 15.5272C9.56484 15.5272 10.5839 15.2721 11.4332 14.8469L14.2358 17.653C14.6604 18.0782 15.3398 18.3333 15.9343 18.3333C16.5287 18.3333 17.1232 18.0782 17.6328 17.653C18.567 16.6326 18.567 15.102 17.6328 14.2517ZM4.89392 12.1258C2.85571 10.085 2.85571 6.76867 4.89392 4.81288C5.91303 3.79248 7.18692 3.28227 8.54573 3.28227C9.90454 3.28227 11.1784 3.79248 12.1975 4.81288C13.2166 5.83329 13.7262 7.1088 13.7262 8.46935C13.7262 9.82989 13.2166 11.1904 12.1975 12.1258C11.1784 13.0612 9.90454 13.6564 8.54573 13.6564C7.18692 13.6564 5.82811 13.1462 4.89392 12.1258Z",
    fill: "#667085"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export default ForwardRef;